import React, {useState} from 'react';
import classNames from "classnames";


export function List(props) {

    const [toggleEdit, setToggleEdit] = useState(false);

    const listClass = classNames("m-0 course-list");
    const listItemClass = classNames("list-item");




    function renderList() {
        if(props.format.ordered) {

            return (
                <ol className={listClass}>
                    {
                        props.children.map(item => (
                            <li className={listItemClass}>
                                {item}
                            </li>
                        ))
                    }
                </ol>
            );
        }

        return (
            <ul className={listClass} >
                {
                    props.children.map(item => (
                        <li className={listItemClass}>
                            {item}
                        </li>
                    ))
                }
            </ul>
        );
    }


    if(props.children != null) {

        return (

            <>
                {renderList()}
            </>

        );
    }




}